class SignatureHelper {
    /**
    * Get the accepted file mime types for a signature.
    */
    public static get acceptedMimeTypes(): string[] {
        return [
            "image/jpeg",
            "image/png",
            "image/gif"
        ];
    }

    /**
    * Validate the signature file format.
    * @param fileType The file type.
    */
    public static isValidFileFormat(fileType: string): boolean {
        return this.acceptedMimeTypes.contains(fileType);
    }

    /**
    * Get a data URL for an image, if it's valid.
    * @param base64 The base64 image data.
    */
    public static getImageDataUrlFromBase64(base64: string): string {
        const imageMime = this.getImageMime(base64);
        return imageMime
            ? `data:${imageMime};base64,${base64}`
            : null;
    }

    /**
    * Get an image's MIME-Type value, if known.
    * @param base64 The base64 image data.
    */
    private static getImageMime(base64: string): string {
        switch (base64?.charAt(0)) {
            case "/":
                return "image/jpeg";

            case "R":
                return "image/gif";

            case "i":
                return "image/png";

            default:
                return null;
        }
    }
}

export { SignatureHelper };
